// src/data/projects.js
import ImageIdentifier from '../assets/image-identifier.webp';
import Symbi          from '../assets/symbi.webp';
import Aquafix        from '../assets/aquafix.webp';
import Particles      from '../assets/particles.webp';
import Digitalclouds  from '../assets/digitalclouds.webp';
import OldPortfolio   from '../assets/old-portfolio.webp';

export const projects = [
  {
    slug: 'image-identifier',
    title: 'Image Identifier',
    tagline: 'AI image analysis built with Next.js and GPT-4V',
    description: "This is a site I'll be launching soon that uses AI to identify and analyze images. It's built with Next.js and powered by OpenAI's GPT-4 with Vision.",
    image: ImageIdentifier,
    stack: ['Next.js', 'OpenAI', 'TypeScript'],
    link: 'https://imageidentifier.ai/',
    featured: true,
    accent: '#a855f7',
    year: '2026',
    category: 'AI',
  },
  {
    slug: 'symbi',
    title: 'Symbi',
    tagline: 'Geo-location app with custom MongoDB backend',
    description: 'I designed and built this site with Next.js featuring geo-location mapping and a custom MongoDB database. Includes dynamic functionality beyond standard frameworks.',
    image: Symbi,
    stack: ['Next.js', 'MongoDB'],
    link: 'https://symbi.se/',
    featured: false,
    accent: '#6366f1',
    year: '2025',
    category: 'WEB',
  },
  {
    slug: 'aquafix',
    title: 'Aquafix',
    tagline: 'WordPress + PHP, custom beyond templates',
    description: 'Designed and built a clean, functional site using WordPress and PHP. It features a blog, contact form, and custom tweaks for flexibility beyond standard functionality.',
    image: Aquafix,
    stack: ['WordPress', 'PHP'],
    link: 'https://aquafix.se/',
    featured: false,
    accent: '#22d3ee',
    year: '2024',
    category: 'WEB',
  },
  {
    slug: 'beam',
    title: 'Beam',
    tagline: 'React Native app overhaul with TypeScript',
    description: 'I was in charge of frontend development for this app, utilizing React Native with TypeScript and Expo. We worked on a major overhaul for the next version; I redesigned and integrated new features to improve the UX.',
    image: Digitalclouds,
    stack: ['React Native', 'TypeScript', 'Expo'],
    link: 'https://play.google.com/store/apps/details?id=com.chargebeam',
    featured: false,
    accent: '#f59e0b',
    year: '2024',
    category: 'APP',
  },
  {
    slug: 'particles',
    title: 'Particles',
    tagline: 'HTML canvas experiment, vanilla JS',
    description: 'This was a fun side project where I experimented with HTML canvas to create a particle effect that interacts with mouse events and a control panel. This is written in vanilla JS, with no frameworks.',
    image: Particles,
    stack: ['JavaScript', 'Canvas'],
    link: 'https://leafy-speculoos-d89fb1.netlify.app/',
    featured: false,
    accent: '#64ffda',
    year: '2023',
    category: 'LAB',
  },
  {
    slug: 'old-portfolio',
    title: 'Old Portfolio',
    tagline: 'GraphQL + Contentful, retro aesthetic',
    description: 'My previous portfolio, reimagined with a retro aesthetic. Built with GraphQL and powered by Contentful for backend management.',
    image: OldPortfolio,
    stack: ['GraphQL', 'Contentful'],
    link: 'https://fabulous-gaufre-631a03.netlify.app/',
    featured: false,
    accent: '#43e97b',
    year: '2022',
    category: 'WEB',
  },
];
